import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FilterState {
  read: 'all' | 'read' | 'unread';
  registration: 'all' | 'registered' | 'unregistered';

  setRead: (read: 'all' | 'read' | 'unread') => void;
  setRegistration: (registration: 'all' | 'registered' | 'unregistered') => void;
  resetFilters: () => void;

  getActiveFilters: () => {
    readed?: boolean;
    registered?: boolean;
  };
}

export const useFilterStore = create<FilterState>()(
  persist(
    (set, get) => ({
      read: 'all',
      registration: 'all',

      setRead: (read) => set({ read }),
      setRegistration: (registration) => set({ registration }),

      resetFilters: () => set({ read: 'all', registration: 'all' }),

      getActiveFilters: () => {
        const { read, registration } = get();
        const result: { readed?: boolean; registered?: boolean } = {};

        if (read !== 'all') {
          result.readed = read === 'read';
        }

        if (registration !== 'all') {
          result.registered = registration === 'registered';
        }

        return result;
      },
    }),
    {
      name: 'chat-filters',
    }
  )
);